const getters = {
  agendaCategoryConfig: (state) => {
    if (!state.tenantList) {
      return undefined;
    }
    const data = state.tenantList.find((t) => t.configname === "category");
    return data || undefined;
  },
  agendaCategories: (state, getters) => {
    const data = getters.agendaCategoryConfig;
    return data ? data.category : [];
  },
  agendaMeetingTypeConfig: (state) => {
    if (!state.tenantList) {
      return undefined;
    }
    const data = state.tenantList.find((t) => t.configname === "meetingType");
    return data || undefined;
  },
  agendaMeetingTypes: (state, getters) => {
    const data = getters.agendaMeetingTypeConfig;
    return data ? data.meetingType : [];
  },
  tenantSettingConfig: (state) => (key) => {
    if (!state.tenantList) {
      return undefined;
    }
    const data = state.tenantList.find((t) => t.configname === key);
    return data || undefined;
  },
  getTemplateByTemplateTypeId: (state, getters) => (id, locale) => {
    const defaultActiveTemplate = state.defaultTemplateList.find(t => t.template_type === id && t.language === locale);
    const templatesList = (getters.tenantSettingTypes("email_templates")?.[id]) || {};
    return Object.values(templatesList).find(obj => obj.active) || defaultActiveTemplate;
  },
  getTemplateByTemplateId: (state, getters) => (template_type, id, locale) => {
    const defaultActiveTemplate = state.defaultTemplateList.find(t => t.template_type === template_type && t.language === locale);
    const templatesList = (getters.tenantSettingTypes("email_templates")?.[template_type]) || {};
    return Object.values(templatesList).find(obj => obj.id === id) || defaultActiveTemplate;
  },
  tenantSettingTypes: (state, getters) => (key) => {
    const data = getters.tenantSettingConfig(key);
    return data ? data[key] : [];
  },
  tenantConfigData: (state, getters) => (key) => {
    const data = getters.tenantSettingConfig(key);
    return data ? data[key] : null;
  },
  masterSettingConfig: (state) => (key) => {
    if (!state.masterSettingList) {
      return undefined;
    }
    const data = state.masterSettingList.find((t) => t.settingname === key);
    return data || undefined;
  },
  masterSettingTypes: (state, getters) => (key) => {
    let data = getters.masterSettingConfig(key);
    
    data = data?.[key]?.slice().sort((a, b) => a.order - b.order);
    return data ? data : [];
  },
};

export default getters;
